module.exports = __webpack_public_path__ + "static/financesBudgetBrusselsLogo-fr-cf3e4ced1136155c1535b77e7def5e78.svg";